import React from "react";
import { Modal } from "react-bootstrap";

export default class AddHomeModal extends React.PureComponent<{}, { showModal: boolean, }> {

    localStorage = window.localStorage;
    constructor(props: any) {
        super(props);
        this.state = { showModal: false };
    }

    componentDidMount() {
        var hasSeen = localStorage.getItem("HasSeenAddHomeModal");

        if (hasSeen == null && hasSeen == undefined) {
            this.setState({ showModal: true });
        }
    }

    closeModal = () => {
        this.setState({ showModal: false });
        localStorage.setItem("HasSeenAddHomeModal", "true")
    }

    render(): React.ReactNode {
        let { showModal } = this.state;
        return (<>
            <Modal show={showModal} onHide={this.closeModal} animation={true}>
                <Modal.Header >
                    <Modal.Title >
                        افزودن اپلیکیشن به منوی گوشی
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{ textAlign: 'center' }}>
                        برای اضافه کردن وب اپلیکیشن به منوی خود , مراحل زیر را انجام دهید.
<br />
<br />
                        1- از پایین صفحه, دکمه اشتراک گذاری را بزنید.
<br />
                        2- گزینه Add to home screen را انتخاب کنید و سپس Add را بزنید.
                    </div>
                </Modal.Body >
                <Modal.Footer dir="ltr">
                    <button className="btn btn btn-primary tk-float-left" onClick={this.closeModal}>متوجه شدم</button>
                </Modal.Footer>
            </Modal>
        </>);
    }
}